import { Inbox as InboxIcon, LogOut, Maximize2, Minimize2, Users } from "lucide-react";

function UtilityBtn({ children, onClick, title, testid }) {
  return (
    <button
      onClick={onClick}
      title={title}
      aria-label={title}
      data-testid={testid}
      className="h-8 w-8 grid place-items-center rounded-md bg-white/80 border border-ink-900/10 text-ink-900/70 hover:text-sun-700 hover:border-sun-500 transition-colors"
    >
      {children}
    </button>
  );
}

/**
 * Top-right utility cluster — admin shortcuts (only for master scope),
 * fullscreen toggle, and logout.
 */
export function DeckUtilityBar({ isMaster, isFull, onFullscreen, onLogout, onAdmin, onInbox }) {
  return (
    <div className="absolute top-4 right-4 z-30 flex items-center gap-1.5">
      {isMaster && (
        <>
          <UtilityBtn onClick={onAdmin} title="Prospects" testid="btn-admin"><Users className="h-3.5 w-3.5" /></UtilityBtn>
          <UtilityBtn onClick={onInbox} title="Inbox" testid="btn-inbox"><InboxIcon className="h-3.5 w-3.5" /></UtilityBtn>
        </>
      )}
      <UtilityBtn onClick={onFullscreen} title="Fullscreen (F)" testid="btn-fullscreen">
        {isFull ? <Minimize2 className="h-3.5 w-3.5" /> : <Maximize2 className="h-3.5 w-3.5" />}
      </UtilityBtn>
      <UtilityBtn onClick={onLogout} title="Log out" testid="btn-logout"><LogOut className="h-3.5 w-3.5" /></UtilityBtn>
    </div>
  );
}
